import {createContext} from "react";

const UiHandlerContext = createContext({
  onButtonError: (e: any) => console.error("Button press resulted in error", e),
});

export default UiHandlerContext;
